const VARIANT = (process.env.REACT_APP_BRAND || '').toLowerCase();
const suffix = VARIANT === 'urclyrd' ? '-urclyrd' : '';
const base = process.env.PUBLIC_URL || '';

export function applyFavicon() {
  const href = `${base}/favicon${suffix}.png`;

  const ensureLink = (rel) => {
    let link = document.querySelector(`link[rel="${rel}"]`);
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', rel);
      document.head.appendChild(link);
    }
    link.setAttribute('href', href);
    link.setAttribute('type', 'image/png');
  };

  ensureLink('shortcut icon');
  ensureLink('icon');
}